document.addEventListener("DOMContentLoaded", () => {

  // ─── Mobile menu ─────────────────────────────────────────────────────────
  const burger = document.querySelector(".js-burger");
  const menu   = document.querySelector(".js-header-nav");
  if (burger && menu) {
    burger.addEventListener("click", () => {
      const open = menu.classList.toggle("active");
      burger.classList.toggle("active", open);
      document.body.classList.toggle("locked", open);
    });
    burger.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        burger.click();
      }
    });
    window.addEventListener("resize", () => {
      if (window.innerWidth > 992) {
        menu.classList.remove("active");
        burger.classList.remove("active");
        document.body.classList.remove("locked");
      }
    });
  }

  // ─── Search overlay ───────────────────────────────────────────────────────
  const openSearchBtn  = document.querySelector(".js-open-search");
  const closeSearchBtn = document.querySelector(".js-close-search");
  const searchOverlay  = document.querySelector(".js-search-overlay");
  if (openSearchBtn && closeSearchBtn && searchOverlay) {
    openSearchBtn.addEventListener("click", (e) => {
      e.preventDefault();
      searchOverlay.classList.add("active");
      document.body.classList.add("locked");
      setTimeout(() => {
        const input = searchOverlay.querySelector("input");
        if (input) input.focus();
      }, 100);
    });
    closeSearchBtn.addEventListener("click", () => {
      searchOverlay.classList.remove("active");
      document.body.classList.remove("locked");
    });
    searchOverlay.addEventListener("click", (e) => {
      if (e.target === searchOverlay) {
        searchOverlay.classList.remove("active");
        document.body.classList.remove("locked");
      }
    });
  }

  // ─── Play deck (interactive) ─────────────────────────────────────────────
  // Data comes from includes/play-ideas.php (window.wpsPlay). Ideas are
  // built with textContent only — never innerHTML.
  const data = window.wpsPlay;
  const deck = document.querySelector(".js-idea");
  const goBtn = document.querySelector(".js-play-go");
  const chips = Array.from(document.querySelectorAll(".js-chip"));
  if (data && data.bands && deck && goBtn && chips.length) {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let band = 0;
    let last = -1;

    const el = (tag, cls, text) => {
      const node = document.createElement(tag);
      if (cls) node.className = cls;
      if (text) node.textContent = text;
      return node;
    };

    const setBand = (i) => {
      band = i;
      last = -1;
      chips.forEach((chip, j) => chip.setAttribute("aria-checked", j === i ? "true" : "false"));
    };

    const draw = () => {
      const ideas = data.bands[band].ideas;
      let k;
      do {
        k = Math.floor(Math.random() * ideas.length);
      } while (k === last && ideas.length > 1);
      last = k;
      const idea = ideas[k];

      const tags = el("div", "idea__tags");
      tags.appendChild(el("span", "tag tag--blue", data.bands[band].label));
      tags.appendChild(el("span", "tag", idea.skill));
      tags.appendChild(el("span", "tag", idea.minutes + " " + data.i18n.minutes));

      const needs = el("p");
      needs.appendChild(el("b", "", data.i18n.needs));
      needs.appendChild(document.createTextNode(" " + idea.needs));

      deck.replaceChildren(tags, el("h3", "", idea.title), needs, el("p", "", idea.text));

      if (!reduce) {
        deck.classList.remove("is-pop");
        void deck.offsetWidth;
        deck.classList.add("is-pop");
      }
    };

    chips.forEach((chip, i) => {
      chip.addEventListener("click", () => {
        setBand(i);
        draw();
      });
    });
    goBtn.addEventListener("click", draw);

    // Month blocks in the hero jump to the deck with a matching idea.
    document.querySelectorAll(".js-month").forEach((block) => {
      block.addEventListener("click", () => {
        const month = parseInt(block.dataset.month, 10);
        setBand(Math.min(data.bands.length - 1, Math.floor((month - 1) / 3)));
        const section = document.getElementById("play");
        if (section) section.scrollIntoView({ behavior: reduce ? "auto" : "smooth" });
        setTimeout(draw, reduce ? 0 : 500);
      });
    });
  }

  // ─── Back to top ─────────────────────────────────────────────────────────
  const backToTop = document.querySelector(".js-back-to-top");
  if (backToTop) {
    const toggle = () => backToTop.classList.toggle("is-visible", window.scrollY > 400);
    window.addEventListener("scroll", toggle, { passive: true });
    toggle();
    backToTop.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

});
